import { useAppLock, WelcomeScreen, SetupScreen, LockScreen } from './components/AppLock/index.ts'
import App from './App.tsx'

export function AppGate() {
  const { isUnlocked, isConfigured, lock, isEnabled, decision, skipEncryption, enableEncryption } = useAppLock()

  if (decision === 'pending') {
    return <WelcomeScreen onEnable={enableEncryption} onSkip={skipEncryption} />
  }

  if (isEnabled && !isConfigured) {
    return (
      <SetupScreen
        onSubmit={async (password) => {
          if (!lock) return
          await lock.setup(password)
        }}
        onSkip={skipEncryption}
      />
    )
  }

  if (isEnabled && isConfigured && !isUnlocked) {
    return (
      <LockScreen
        onUnlock={async (password) => {
          if (!lock) return false
          return lock.unlock(password)
        }}
      />
    )
  }

  if (!isUnlocked) {
    return null
  }

  return <App />
}
